export default __webpack_public_path__ + "static/media/logo-sww.7128558e.svg";